/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import styled from '@emotion/styled';
import { css } from 'emotion';

import { TextColor } from '../styles/colors';

import { ExternalSourcePropTypes } from './ExternalSourceShape';

import { TextFontStyles } from './styles';

import LinkIconImg from './icons/outline-launch-24px.svg';
import ImageIconImg from './icons/outline-image-24px.svg';
import VideoIconImg from './icons/outline-movie-24px.svg';
import PdfIconImg from './icons/outline-picture_as_pdf-24px.svg';

import { LE1 } from '../LE/LE1';
import { LE1_2 } from '../LE/LE1_2';
import { LE1_3 } from '../LE/LE1_3';
import { LE1_4 } from '../LE/LE1_4';
import { LE2 } from '../LE/LE2';
import { LE2_2 } from '../LE/LE2_2';
import { LE2_3 } from '../LE/LE2_3';
import { LE2_4 } from '../LE/LE2_4';
import { LE3 } from '../LE/LE3';
import { LE3_2 } from '../LE/LE3_2';
import { LE3_3 } from '../LE/LE3_3';
import { LE3_4 } from '../LE/LE3_4';
import { LE3_5 } from '../LE/LE3_5';
import { LE3_6 } from '../LE/LE3_6';
import { LE3_7 } from '../LE/LE3_7';
import { LE4 } from '../LE/LE4';
import { LE4_2 } from '../LE/LE4_2';
import { LE4_2b } from '../LE/LE4_2b';
import { LE4_3 } from '../LE/LE4_3';
import { LE4_4 } from '../LE/LE4_4';
import { MORE_MATERIAL_AND_TIPS } from '../LE/MORE_MATERIAL_AND_TIPS';

const COMPONENTS = {
  LE1,
  LE1_2,
  LE1_3,
  LE1_4,
  LE2,
  LE2_2,
  LE2_3,
  LE2_4,
  LE3,
  LE3_2,
  LE3_3,
  LE3_4,
  LE3_5,
  LE3_6,
  LE3_7,
  LE4,
  LE4_2,
  LE4_2b,
  LE4_3,
  LE4_4,
  MORE_MATERIAL_AND_TIPS,
};

const TypeExtStyles = {
  pdf: css`
    background-image: url(${PdfIconImg});
  `,
  image: css`
    background-image: url(${ImageIconImg});
  `,
  video: css`
    background-image: url(${VideoIconImg});
  `,
  link: css`
    background-image: url(${LinkIconImg});
  `,
  component: css`
    display: none;
  `,
  notype: css`
    display: none;
  `,
};

const Container = styled.li`
  position: relative;
  margin-left: ${({ indent }) => `${indent * 20}px`};
  margin-bottom: 15px;
  list-style-type: none;
`;

const TypeStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;

  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

const Body = styled.div`
  ${TextFontStyles};

  padding-left: ${({ type }) => (type === 'notype' ? '0' : '55px')};
`;

const LinkList = styled.ul`
  padding: 0;
`;

const LinkItem = styled.li`
  list-style-type: none;
  padding-left: 55px;

  text-overflow: ellipsis;
  overflow: hidden;
`;

const LINK_TARGET = '_blank';
const LINK_REL = 'noopener noreferrer';

const Link = ({ href, download }) => (
  <LinkItem>
    { download
      ? (
        <a href={href} download={download}>{ download }</a>
      ) : (
        <a href={href} target={LINK_TARGET} rel={href && href[0] === '/' ? undefined : LINK_REL}>{ href && href.replace(/^(\/[^/]+)*\//g, '') }</a>
      )
    }
  </LinkItem>
);

const parseAutoLinks = text => text.replace(
  /(https?:\/\/[^ ]*[^ ,.])/g,
  `<a href="$1" style="color:${TextColor}" target="${LINK_TARGET}" rel="${LINK_REL}">$1</a>`,
);

const Urls = ({ url, download }) => (
  Array.isArray(url)
    ? (
      <LinkList>
        { url.map(href => (
          <Link key={href} href={href} />
        )) }
      </LinkList>
    ) : (
      <LinkList>
        <Link href={url} download={download} />
      </LinkList>
    )
);

const ExternalSource = ({ type, body, url, download, indent }) => {
  const BodyComponent = type === 'component' ? COMPONENTS[body] : undefined;

  return (
    <Container indent={indent}>
      <div className={css([TypeStyles, TypeExtStyles[type]])} />
      {(BodyComponent && (
        <BodyComponent />
      )) || (
        <Body type={type} dangerouslySetInnerHTML={{ __html: parseAutoLinks(body) }} />
      )}
      <Urls url={url} download={download} />
    </Container>
  );
};

ExternalSource.propTypes = ExternalSourcePropTypes;

ExternalSource.defaultProps = {
  type: 'notype',
  url: undefined,
  download: undefined,
  indent: 0,
};

export default ExternalSource;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalSource.js